import { useClipboard } from '@calendly/clipboard';
import { I18n } from '@calendly/i18n';
import { CopyIcon, CheckCircleIcon } from '@calendly/ui/components/icons';
import { colorTextInverseStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useEffect, useContext, forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { dispatchSegmentEvent } from 'features/tracked_meetings/status/completed/useSegment';
import { useTrack } from 'hooks/analytics_events';
import { ShareContext } from '../context';
const styledDivButtonCss = "sqtg2ry";
const StyledDivButton = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledDivButtonCss, props.className)} />;
});
const styledDivCopiedButtonCss = "seq4cws";
const StyledDivCopiedButton = forwardRef((props, ref) => <StyledDivButton ref={ref} {...props} className={classNames(styledDivCopiedButtonCss, props.className)} />);
export const ModalCopyButton = ({
  content
}) => {
  const {
    foreignEventId,
    foreignEventProvider,
    shareUuid,
    eventUuid
  } = useContext(ShareContext);
  const user = useGetUserQuery();
  const track = useTrack();
  const [Wrapper, ref, isCopied] = useClipboard(content);
  const initialLabel = I18n.t('publisher.meeting_intelligence.share.copy_button');
  const copiedLabel = I18n.t('publisher.meeting_intelligence.share.copied');
  useEffect(() => {
    if (isCopied) {
      dispatchSegmentEvent(track, user.data, foreignEventId, foreignEventProvider === 'Calendly', 'user_shared_summary', eventUuid, {
        share_uuid: shareUuid,
        share_method: 'copy'
      });
    }
  }, [isCopied, foreignEventId, foreignEventProvider, shareUuid, user.data, eventUuid, track]);
  return <Wrapper>
      {isCopied ? <StyledDivCopiedButton ref={ref} copied={isCopied.toString()}>
              <CheckCircleIcon color={colorTextInverseStandard} />
              <p>{copiedLabel}</p>
            </StyledDivCopiedButton> : <StyledDivButton ref={ref} copied={isCopied.toString()}>
              <CopyIcon color={colorTextInverseStandard} />
              <p>{initialLabel}</p>
            </StyledDivButton>}
    </Wrapper>;
};

require("./modal_copy_button.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./modal_copy_button.js");